import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./index";
import { tenantCategoryAPI } from "../modules/tenant-category/apiService/tenant-category-api-service";
import { findingSummaryApi } from "../modules/assessments/apiService/assessment-findings-api-service";
import { milestoneFindingSummaryApi } from "../modules/assessments/apiService/milestone-findings-api-service";
import { wafrFindingsFiltersApi } from "../modules/assessments/apiService/findings-filters-api-service";

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }).concat(
      tenantCategoryAPI.middleware,
      findingSummaryApi.middleware,
      milestoneFindingSummaryApi.middleware,
      wafrFindingsFiltersApi.middleware
    ),
});

export default store;
